<template>
  <path
    d="M16.24 7.76024C15.07 6.59024 13.54 6.00024 12 6.00024V12.0002L7.76 16.2402C10.1 18.5802 13.9 18.5802 16.25 16.2402C18.59 13.9002 18.59 10.1002 16.24 7.76024ZM12 2.00024C6.48 2.00024 2 6.48024 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48024 17.52 2.00024 12 2.00024ZM12 20.0002C7.58 20.0002 4 16.4202 4 12.0002C4 7.58024 7.58 4.00024 12 4.00024C16.42 4.00024 20 7.58024 20 12.0002C20 16.4202 16.42 20.0002 12 20.0002Z"
  />
</template>
